/* component-product-recommendations.js — <product-recommendations>
   Lazily fetches the Recommendations-API-rendered section HTML the first time
   the element nears the viewport, then swaps its own innerHTML. If Shopify
   already rendered recommendations server-side, the fetch still refreshes with
   the intent/limit params but is harmless. */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.url = this.dataset.url;
    if (!this.url) return;
    if ('IntersectionObserver' in window) {
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { this.load(); this._io.disconnect(); }
        });
      }, { rootMargin: '400px' });
      this._io.observe(this);
    } else {
      this.load();
    }
  }

  disconnectedCallback() { if (this._io) this._io.disconnect(); }

  load() {
    if (this._loaded) return;
    this._loaded = true;
    fetch(this.url)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
